module.exports = __webpack_public_path__ + "img/Thumbnail2.png";